export default {"src":"/_next/static/media/ico-bandits.00c2a2c8.svg","height":540,"width":525,"blurWidth":0,"blurHeight":0};